import { ListingTranslation } from 'ha/services/apiV2/types/ListingTranslation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  listingId: number;
  targetLang: string;
}

export default (makeCall: MakeCall) => ({ listingId, targetLang }: Payload) =>
  makeCall<ListingTranslation>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/translate/description/${targetLang}`,
  );
